import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { addOrUpdateItem } from '../ActionsBevego/FavouriteList.action'

const FavouriteButton = (props) => {
    const dispatch = useDispatch();
    const [favouriteClass, setFavouriteClass] = useState(props.favouriteClass);
    const handleAddOrUpdate = () => {
        dispatch(addOrUpdateItem(props.articleNumber))
            .then(isInlist => {
                setFavouriteClass(isInlist ? "is-favourite" : "");
            });
    };

    return (
        <div>
            <span className={`product-detail__favourite ${favouriteClass}`} onClick={() => handleAddOrUpdate()}></span>
        </div>
    );
};

export default FavouriteButton;
